import React from 'react';
import TinyDatePicker from 'tiny-date-picker';
import DateSelectorView from './DateSelectorView';
import './tiny-date-picker.css';

class DateSelectorController extends React.Component {
	constructor(props) {
		super(props);
		this.className = 'date-selector-' + props.name;
	}
	componentDidMount() {
		const className = '.' + this.className;
		setTimeout(() => { // probablt not needed. only here to give dom time to render something to bind on to, but the function should only be called when that's the case.
			const tdp = TinyDatePicker(className);
			tdp.on('select', (_,data)=>{
				this.props.onChange({target:{
					name: this.props.name,
					value: data.state.selectedDate.toISOString().substr(0, 10)
				}});
			});
		}, 1000);
	}
	render() {
		return <DateSelectorView {...this.props} className={this.className} />;
	}
}

export default DateSelectorController;


// WEBPACK FOOTER //
// ./src/components/dateSelector/DateSelectorController.js